import { render, staticRenderFns } from "./AvailabilityStatus.vue?vue&type=template&id=436db5ec&"
import script from "./AvailabilityStatus.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436db5ec')) {
      api.createRecord('436db5ec', component.options)
    } else {
      api.reload('436db5ec', component.options)
    }
    module.hot.accept("./AvailabilityStatus.vue?vue&type=template&id=436db5ec&", function () {
      api.rerender('436db5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/AvailabilityStatus.vue"
export default component.exports